import { env } from "md-base-tools/env";
import { getCategoryMonthShareImge } from "@api/index";
import CompLottieAnimation from "@@/lottieAnimation.vue";
import { mdToast } from '@/utils/tools';
import { showLoadingToast, closeToast } from 'vant';
export default {
  name: 'popup-prize',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    prizeInfo: {
      type: Object,
      default: () => ({
        is_free: false,
        cashback_amount: 0,
        img: '',
        reward_title: '',
        order_id: ''
      })
    }
  },
  components: {
    CompLottieAnimation
  },
  computed: {
    show_pop: {
      get() {
        return this.show;
      },
      set() {}
    }
  },
  data() {
    return {
      showLottieAnimation: true,
      showPrize: false
    };
  },
  watch: {
    show_pop(newVal) {
      if (newVal) {
        this.showLottieAnimation = true;
      }
    }
  },
  methods: {
    closePopup() {
      this.showPrize = false;
      this.$emit('update:show', false);
    },
    handleShareAction() {
      this.closePopup();
      this.$emit('handleShareAction');
    },
    onAnimationComplete() {
      this.showLottieAnimation = false;
      this.showPrize = true;
    },
    // 再抽一次
    drawAgain() {
      this.closePopup();
      this.$emit('openDraw');
    },
    // 保存图片
    saveImage() {
      showLoadingToast({
        message: '保存中...',
        forbidClick: true,
        duration: 0
      });
      // 调用接口获取分享图片
      getCategoryMonthShareImge({
        order_id: this.prizeInfo.order_id
      }).then(res => {
        closeToast();
        if (res.status == 0 && res.data && res.data.share_img) {
          const shareImgUrl = res.data.share_img;
          if (env.isModianIos() || env.isModianAndroid()) {
            // 客户端环境：下载图片转base64
            this.downloadImageAsBase64(shareImgUrl).then(base64 => {
              // eslint-disable-next-line no-undef
              graft.app({
                functionName: "saveImage",
                functionParams: base64,
                callBack: e => {
                  if (e.errorCode == 0) {
                    mdToast('保存成功');
                  }
                }
              });
            }).catch(() => {
              mdToast('保存失败');
            });
          } else if (env.isWxApp()) {
            // 微信小程序环境：预览大图
            // eslint-disable-next-line no-undef
            wx.previewImage({
              urls: [shareImgUrl]
            });
          } else {
            // H5环境：直接下载
            this.downloadImage(shareImgUrl);
          }
        } else {
          mdToast('获取图片失败');
        }
      }).catch(() => {
        mdToast('获取图片失败');
      });
    },
    // 下载图片转base64
    downloadImageAsBase64(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL('image/png');
          resolve(dataURL);
        };
        img.onerror = function () {
          reject(new Error('图片加载失败'));
        };
        img.src = url;
      });
    },
    // H5环境下载图片
    downloadImage(url) {
      // 使用 fetch 获取图片数据
      fetch(url).then(response => response.blob()).then(blob => {
        // 创建 blob URL
        const blobUrl = window.URL.createObjectURL(blob);

        // 创建下载链接
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = new Date().getTime() + '.png';

        // 触发下载
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // 释放 blob URL
        window.URL.revokeObjectURL(blobUrl);
        mdToast('图片已保存');
      }).catch(() => {
        mdToast('下载失败');
      });
    }
  }
};